<template>
  <div>
    <tooltip label="View" type="default" placement="left">
      <a class="button button-table is-small" @click="view()">
        <i class="fa fa-eye"></i>
      </a>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import message from '../../utils/message'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      view () {
        window.open('#/finances/account/' + this.data.id)
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// AccountsTableButtons.vue?1b2cd9a0